import { render, staticRenderFns } from "./ListReferencia.vue?vue&type=template&id=059ac1b2"
import script from "./ListReferencia.vue?vue&type=script&lang=js"
export * from "./ListReferencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports